import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import ROUTES from '~/shared/constants/routes.const'

interface PaywallState {
  returnPath: string
}
const initialState: PaywallState = {
  returnPath: ROUTES.DASHBOARD,
}

const slice = createSlice({
  name: 'paywall',
  initialState,
  reducers: {
    setReturnPath: (state, action: PayloadAction<PaywallState['returnPath']>) => ({
      ...state,
      returnPath: action.payload,
    }),
  },
})

export const selectReturnPath = (state: RootState): PaywallState['returnPath'] => {
  return state.paywall.returnPath
}

export const { setReturnPath } = slice.actions

export default slice.reducer
